<template>
  <a-space class="ali-filter-space">
    <a-checkbox-group v-model:value="params" @change="changeFilter">
      <a-checkbox v-for="item in list" :key="item.desc" :value="item.key">
      {{ item.desc }}
    </a-checkbox>
    </a-checkbox-group>
  </a-space>
</template>
<script>
import handler from './handler'
export default {
  data() {
    return {
      params: [],
      list: []
    }
  },
  methods: {
    async getFilterOptions() {
      this.list = await handler.GetProductFilter()
    },
    changeFilter() {
      const params = this.params?.length ? this.params.join(',') : ''
      localStorage.setItem('xf_1688_jx_filters', params)
      this.$emit('change-filter', params)
    },
  },
  mounted() {
    const data = localStorage.getItem('xf_1688_jx_filters')
    this.params = data ? data.split(',') : []
    this.getFilterOptions()
  }
}
</script>
<style scoped lang='less'>
  .ali-filter-space {
    display: flex;
    margin: .32em 0;
    :deep(.ant-checkbox-wrapper) {
      font-size: 14px;
      .ant-checkbox-checked {
        + span {
          color: #007fff;
        }
      }
    }
  }
</style>